import { FoodsTextInput } from "@foodpilot/foods";
import { MRT_RowData } from "material-react-table";
import { useDelayedSearch } from "src/utils/useDelayedSearch";
import { CustomMRTFilter } from "./mrt.types";

type CustomFilterProps<T extends MRT_RowData> = {
    mrtProps: CustomMRTFilter<T>;
};
export const StringFilter = <T extends MRT_RowData>(props: CustomFilterProps<T>) => {
    const { mrtProps } = props;

    const initFilterValue = mrtProps.column.getFilterValue() as string | undefined;

    const searchApi = useDelayedSearch({
        startSearch: initFilterValue ?? "",
        actionOnDelay: (validatedSearch) => {
            mrtProps.column.setFilterValue(validatedSearch);
        },
    });

    return (
        <FoodsTextInput
            value={searchApi.search}
            onChange={searchApi.setSearch}
            ExtraInputProps={{
                autoFocus: true,
                onKeyDown: (e) => {
                    e.stopPropagation();
                    if (e.key === "Enter") {
                        searchApi.flushSearch();
                    }
                },
            }}
        />
    );
};
